module.exports = __webpack_public_path__ + "static/media/streamline-icon.944c3a3c.svg";